import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import omit from 'lodash/omit';

import {
  actionsForCurrentDeviceSelector,
  attachmentsForCurrentDeviceSelector,
  currentDeviceSelector,
  currentUserSelector,
  labelsForCurrentSiteSelector,
  labelsForCurrentDeviceSelector,
  membershipsForCurrentFactorySelector,
  pathSelector,
  factoriesToLinesForCurrentUserSelector,
  alarmsForCurrentDeviceSelector,
  usersForCurrentDeviceSelector,
} from '../selectors';
import {
  addLabelToCurrentDevice,
  addUserToCurrentDevice,
  createAttachmentInCurrentDevice,
  createCommentActionInCurrentDevice,
  createLabelInCurrentSite,
  createAlarmInCurrentDevice,
  deleteAttachment,
  deleteCommentAction,
  deleteCurrentDevice,
  deleteLabel,
  deleteAlarm,
  fetchActionsInCurrentDevice,
  fetchSite,
  moveCurrentDevice,
  removeLabelFromCurrentDevice,
  removeUserFromCurrentDevice,
  transferCurrentDevice,
  updateAttachment,
  updateCommentAction,
  updateCurrentDevice,
  updateLabel,
  updateAlarm,
} from '../actions/entry';
import Paths from '../constants/Paths';
import DeviceModal from '../components/DeviceModal';

const mapStateToProps = (state) => {
  const { factoryId } = pathSelector(state);
  const currentUser = currentUserSelector(state);
  const allFactoriesToLines = factoriesToLinesForCurrentUserSelector(state);
  const allFactoryMemberships = membershipsForCurrentFactorySelector(state);
  const allLabels = labelsForCurrentSiteSelector(state);

  const {
    name,
    description,
    dueDate,
    timer,
    isSubscribed,
    isActionsFetching,
    isAllActionsFetched,
    siteId,
    lineId,
  } = currentDeviceSelector(state);

  const users = usersForCurrentDeviceSelector(state);
  const labels = labelsForCurrentDeviceSelector(state);
  const alarms = alarmsForCurrentDeviceSelector(state);
  const attachments = attachmentsForCurrentDeviceSelector(state);
  const actions = actionsForCurrentDeviceSelector(state);

  return {
    name,
    description,
    dueDate,
    timer,
    isSubscribed,
    isActionsFetching,
    isAllActionsFetched,
    lineId,
    siteId,
    factoryId,
    users,
    labels,
    alarms,
    attachments,
    actions,
    allFactoriesToLines,
    allFactoryMemberships,
    allLabels,
    isEditable: currentUser.isAdmin,
    currentUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUpdate: updateCurrentDevice,
      onMove: moveCurrentDevice,
      onTransfer: transferCurrentDevice,
      onDelete: deleteCurrentDevice,
      onUserAdd: addUserToCurrentDevice,
      onUserRemove: removeUserFromCurrentDevice,
      onSiteFetch: fetchSite,
      onLabelAdd: addLabelToCurrentDevice,
      onLabelRemove: removeLabelFromCurrentDevice,
      onLabelCreate: createLabelInCurrentSite,
      onLabelUpdate: updateLabel,
      onLabelDelete: deleteLabel,
      onAlarmCreate: createAlarmInCurrentDevice,
      onAlarmUpdate: updateAlarm,
      onAlarmDelete: deleteAlarm,
      onAttachmentCreate: createAttachmentInCurrentDevice,
      onAttachmentUpdate: updateAttachment,
      onAttachmentDelete: deleteAttachment,
      onActionsFetch: fetchActionsInCurrentDevice,
      onCommentActionCreate: createCommentActionInCurrentDevice,
      onCommentActionUpdate: updateCommentAction,
      onCommentActionDelete: deleteCommentAction,
      push,
    },
    dispatch,
  );

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...omit(dispatchProps, 'push'),
  onClose: () => dispatchProps.push(Paths.SITES.replace(':id', stateProps.siteId)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeviceModal);
